import { AppState } from "../AppState"

export const selectConfirmationPending = (s: AppState) => s.confirmation.pending
export const selectConfirmationFetchError = (s: AppState) =>
  s.confirmation.error
export const selectConfirmationPagination = (s: AppState) =>
  s.confirmation.pagination

export const selectConfirmationList = (s: AppState) => s.confirmation.data || []
